export const isRoleDescriptionValid = (roleDescription: string) => roleDescription.trim().length >= 6;
